import React from "react";
import {
  useNavigate,
  useParams,
} from "react-router-dom";
import titleize from "underscore.string/titleize";
import OfferUpdates from "./../components/offer/updates";
import { useSessionContext } from "../contexts/SessionContext";
import { CompanyContext } from "../contexts/CompanyContext";
import {
  Layouts,
} from "./../components";

function OfferUpdateEditor() {
  const navigate = useNavigate();
  let { offer_id, update_id } = useParams();
  const { selectedCompany } = React.useContext(CompanyContext);
  const { isPermitted, ACTIONS } = useSessionContext();

  if(!isPermitted(ACTIONS.WRITE_UPDATE_OFFER_UPDATE, selectedCompany.id)) {
    return (
      <div className="content-centered">
        You are not authorised to create/edit offer updates.
      </div>
    )
  }

  return (
    <div className="bg-white mvh-100">
      <Layouts.PageHeader left={titleize(update_id ? "Edit Offer Update" : "New Offer Update")} />
      <div className="px-3">
        <OfferUpdates.Form offerId={offer_id} updateId={update_id} onSuccess={() => navigate(-1) }/>
      </div>
    </div>
  )
}

export default OfferUpdateEditor;